import { render } from "./NotificationsComponent.vue?vue&type=template&id=369f8cea&scoped=true"
import script from "./NotificationsComponent.vue?vue&type=script&lang=js"
export * from "./NotificationsComponent.vue?vue&type=script&lang=js"

import "./NotificationsComponent.vue?vue&type=style&index=0&id=369f8cea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369f8cea"]])

export default __exports__